<template>
  <!-- 設定 ダイアログ -->
  <v-dialog v-model="showSettingDialog" fullscreen transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar >
        <v-toolbar-title v-if="selectEditServiceId==1" > {{locationName}} > {{filtrationSystemName}} > {{$t('service.flow-and-time')}} {{$t('settings.title')}} </v-toolbar-title>
        <v-toolbar-title v-if="selectEditServiceId==2" > {{locationName}} > {{filtrationSystemName}} > {{$t('service.ro-membrane')}} {{$t('settings.title')}} </v-toolbar-title>
        <v-toolbar-title v-if="selectEditServiceId==3" > {{locationName}} > {{filtrationSystemName}} > {{$t('service.temperature')}} {{$t('settings.title')}} </v-toolbar-title>
        <v-toolbar-title v-if="selectEditServiceId==5" > {{locationName}} > {{filtrationSystemName}} > {{$t('service.pressure')}} {{$t('settings.title')}} </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeSettingDialog(false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
          <v-container grid-list-md>
            <v-layout  wrap>
                <h4 class="setting-dialog-threshold-h">{{$t('watersystem.threshold')}}</h4>
                <v-btn @click="openHelpDialog()" >
                  <v-icon class="body-1" large>info</v-icon>
                  <span v-if="selectEditServiceId==1" >{{$t('watersystem.about-flow-and-time')}}</span>
                  <span v-if="selectEditServiceId==2" >{{$t('watersystem.about-ro-membrane')}}</span>
                  <span v-if="selectEditServiceId==3" >{{$t('watersystem.about-temperature')}}</span>
                  <span v-if="selectEditServiceId==5" >{{$t('watersystem.about-pressure')}}</span>
                </v-btn>
                <help-dialog
                ref="childHelpDialog"
                >
                </help-dialog>
            </v-layout>
            <v-flex xs12 sm6 md4>
              <v-radio-group v-model="presetRadio"  row>
                <v-radio :label="$t('watersystem.custom')" value="0"></v-radio>
                <v-radio :label="$t('watersystem.use-preset')" value="1" disabled></v-radio>
              </v-radio-group>
            </v-flex>
            <v-form
              v-model="settingDialogValid"
              ref="settingForm"
            >
              <div v-if="selectEditServiceId==1">
                  <h3>{{$t("watersystem.flow-life")}}</h3>
                  <v-layout  wrap>
                    <v-flex xs12 sm6 md2>
                      <v-icon class="red--text" >
                        fiber_manual_record
                      </v-icon>
                      {{$t("watersystem.alert")}}
                      <v-text-field
                      v-model="flowEditData.maxFlowLifeSpan"
                      :suffix="unit"
                      :rules="lifespanFrowRateAlertRules"
                      v-on:keyup="settingFormValidate"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-icon class="orange--text" >
                        fiber_manual_record
                      </v-icon>
                      {{$t("watersystem.warning")}}
                      <v-text-field
                      v-model="flowEditData.warningFlowLifeSpan"
                      :suffix="unit"
                      :rules="lifespanFrowRateWarningRules"
                      v-on:keyup="settingFormValidate"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <h3>{{$t("watersystem.time-life")}}</h3>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md2>
                      <v-icon class="red--text" >
                        fiber_manual_record
                      </v-icon>
                      {{$t("watersystem.alert")}}
                      <v-text-field
                      v-model="flowEditData.maxUptimeLifeSpan"
                      :suffix='$t("watersystem.period-month")'
                      :rules="lifespanMonthAlertRules"
                      v-on:keyup="settingFormValidate"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-icon class="orange--text" >
                        fiber_manual_record
                      </v-icon>
                      {{$t("watersystem.warning")}}
                      <v-text-field
                      v-model="flowEditData.warningUptimeLifeSpan"
                      :suffix='$t("watersystem.period-month")'
                      :rules="lifespanMonthWarningRules"
                      v-on:keyup="settingFormValidate"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
              </div>

              <v-layout
              v-if="selectEditServiceId==2"
              wrap
              >
                <v-flex xs12 sm6 md2>
                  <v-icon class="red--text" >
                    fiber_manual_record
                  </v-icon>
                  {{$t("watersystem.alert")}}
                  <v-text-field
                  v-model="roEditData.alertRate"
                  suffix="%"
                  :rules="roRateAlertRules"
                  v-on:keyup="settingFormValidate"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-icon class="orange--text" >
                    fiber_manual_record
                  </v-icon>
                  {{$t("watersystem.warning")}}
                  <v-text-field
                  v-model="roEditData.warningRate"
                  suffix="%"
                  :rules="roRateWarningRules"
                  v-on:keyup="settingFormValidate"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout v-if="selectEditServiceId==3">
                <v-flex xs3>
                  {{$t('watersystem.temperature-select-label')}}
                  <v-select
                    :items="items"
                    :rules="tempretureSelectRules"
                    item-text="label"
                    item-value="value"
                    :label="selectTempretureItem"
                    v-model="temperatureEditData.validationType"
                    v-on:change="settingFormValidate"
                    single-line
                    bottom
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout v-if="selectEditServiceId==3">
                <v-flex xs12 sm6 md2 v-if="temperatureEditData.validationType==1">
                  <v-icon class="red--text" >
                    fiber_manual_record
                  </v-icon>
                  {{$t("watersystem.alert")}}
                  <v-text-field
                  v-model="temperatureEditData.alertRate.min"
                  type="number"
                  :suffix="temperatureUnitMin"
                  :rules="tempretureAlertRules"
                  v-on:click="settingFormValidate"
                  v-on:keyup="settingFormValidate"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2 v-if="temperatureEditData.validationType==2">
                  <v-icon class="red--text" >
                    fiber_manual_record
                  </v-icon>
                  {{$t("watersystem.alert")}}
                  <v-text-field
                  v-model="temperatureEditData.alertRate.max"
                  type="number"
                  :suffix="temperatureUnitMax"
                  :rules="tempretureAlertRules"
                  v-on:click="settingFormValidate"
                  v-on:keyup="settingFormValidate"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2 v-if="temperatureEditData.validationType==1">
                  <v-icon class="orange--text" >
                    fiber_manual_record
                  </v-icon>
                  {{$t("watersystem.warning")}}
                  <v-text-field
                  v-model="temperatureEditData.warningRate.min"
                  type="number"
                  :suffix="temperatureUnitMin"
                  :rules="tempretureWarningRules"
                  v-on:click="settingFormValidate"
                  v-on:keyup="settingFormValidate"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2 v-if="temperatureEditData.validationType==2">
                  <v-icon class="orange--text" >
                    fiber_manual_record
                  </v-icon>
                  {{$t("watersystem.warning")}}
                  <v-text-field
                  v-model="temperatureEditData.warningRate.max"
                  type="number"
                  :suffix="temperatureUnitMax"
                  :rules="tempretureWarningRules"
                  v-on:click="settingFormValidate"
                  v-on:keyup="settingFormValidate"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout
              v-if="selectEditServiceId==5"
              wrap
              >
                <v-flex xs12>
                  <v-checkbox
                  :label="$t('watersystem.differential-pressure')"
                  v-model="pressEditData.isDifferentialPressure"
                  v-on:change="settingFormValidate"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-icon class="red--text" >
                    fiber_manual_record
                  </v-icon>
                  {{$t("watersystem.alert")}}
                  <v-text-field
                  v-model="pressEditData.alertRate"
                  :suffix="pressureUnit"
                  :rules="pressureAlertRules"
                  v-on:keyup="settingFormValidate"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-icon class="orange--text" >
                    fiber_manual_record
                  </v-icon>
                  {{$t("watersystem.warning")}}
                  <v-text-field
                  v-model="pressEditData.warningRate"
                  :suffix="pressureUnit"
                  :rules="pressureWarningRules"
                  v-on:keyup="settingFormValidate"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout
                v-if="selectEditServiceId == 1"
                wrap
              >
                <v-flex xs12 sm4>
                  <v-icon class="blue--text" >
                    fiber_manual_record
                  </v-icon>
                  {{$t("watersystem.use-flow")}}
                  <v-select
                    v-model="flowEditData.pluginInfoId"
                    :items="flowsensors"
                    item-text="name"
                    item-value="id"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-btn
                color="primary"
                class="ml-4"
                :disabled="(!settingDialogValid || isRoot)"
                @click.native="updateConfig()"
              >
                {{execBtnName}}
              </v-btn>
              <v-btn
                color="nomal"
                class="ml-4"
                @click.native="closeSettingDialog(false)"
              >
                {{$t('btn.cancel')}}
              </v-btn>
            </v-form>
          </v-container>
        </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>

import config from '@/config.js'
import http from '@/utils/http.js'
import utils from '@/utils/utils.js'
import HelpDialog from '@/components/HelpDialog.vue'

export default {
  components: {
    HelpDialog
  },
  name: 'ServiceSettinDialog',
  data () {
    return {
      selectEditServiceId: 0,
      selectEditPort: 0,
      locationName: '',
      filtrationSystemId: null,
      filtrationSystemName: '',
      editData: [],
      selectTempretureItem: '',
      items: [
        { label: this.$t('watersystem.temperature-increase'), value: '1' },
        { label: this.$t('watersystem.temperature-decrease'), value: '2' }
      ],
      showSettingDialog: false,
      unit: this.$store.getters.settingParams.unit,
      pressureUnit: this.$store.getters.settingParams.pressureUnit,
      temperatureUnit: this.$store.getters.settingParams.temperatureUnit,
      temperatureUnitMin: this.$store.getters.settingParams.temperatureUnit + ' ' + this.$t('watersystem.temperature-min'),
      temperatureUnitMax: this.$store.getters.settingParams.temperatureUnit + ' ' + this.$t('watersystem.temperature-max'),
      presetRadio: '0',
      flowEditData: {
        maxFlowLifeSpan: '',
        warningFlowLifeSpan: '',
        maxUptimeLifeSpan: '',
        warningUptimeLifeSpan: '',
        pluginInfoId: ''
      },
      roEditData: {
        alertRate: '',
        warningRate: ''
      },
      temperatureEditData: {
        portNumber: '',
        validationType: '',
        alertRate: {
          min: '',
          max: ''
        },
        warningRate: {
          min: '',
          max: ''
        }
      },
      pressEditData: {
        portNumber: '',
        alertRate: '',
        warningRate: '',
        isDifferentialPressure: false
      },
      flowsensors: [],
      settingDialogValid: false,
      isRoot: false, // ルートユーザかどうか
      execBtnName: this.$t('btn.save'),
      lifespanFrowRateWarningRules: [
        (v) => v.length !== 0 || this.$t('watersystem.vali-threshold-must'),
        (v) => !isNaN(v) || this.$t('watersystem.vali-threshold-num'),
        (v) => v <= config.serviceConfig[1]['flow']['range']['max'] || this.$t('watersystem.vali-threshold-max-comm', [config.serviceConfig[1]['flow']['range']['max'] + this.unit]),
        (v) => v >= config.serviceConfig[1]['flow']['range']['min'] || this.$t('watersystem.vali-threshold-min-comm', [config.serviceConfig[1]['flow']['range']['min'] + this.unit]),
        (v) => Number.isInteger(parseFloat(v)) || this.$t('watersystem.vali-threshold-integer'),
        (v) => this.thresholdCorrelationValidationCase2(this.flowEditData.maxFlowLifeSpan, this.flowEditData.warningFlowLifeSpan) || this.$t('watersystem.vali-threshold-alert-less-than')
      ],
      lifespanFrowRateAlertRules: [
        (v) => v.length !== 0 || this.$t('watersystem.vali-threshold-must'),
        (v) => !isNaN(v) || this.$t('watersystem.vali-threshold-num'),
        (v) => v <= config.serviceConfig[1]['flow']['range']['max'] || this.$t('watersystem.vali-threshold-max-comm', [config.serviceConfig[1]['flow']['range']['max'] + this.unit]),
        (v) => v >= config.serviceConfig[1]['flow']['range']['min'] || this.$t('watersystem.vali-threshold-min-comm', [config.serviceConfig[1]['flow']['range']['min'] + this.unit]),
        (v) => Number.isInteger(parseFloat(v)) || this.$t('watersystem.vali-threshold-integer'),
        (v) => this.thresholdCorrelationValidationCase2(this.flowEditData.maxFlowLifeSpan, this.flowEditData.warningFlowLifeSpan) || this.$t('watersystem.vali-threshold-greater-than-warning')
      ],
      lifespanMonthWarningRules: [
        (v) => v.length !== 0 || this.$t('watersystem.vali-threshold-must'),
        (v) => !isNaN(v) || this.$t('watersystem.vali-threshold-num'),
        (v) => v <= config.serviceConfig[1]['time']['range']['max'] || this.$t('watersystem.vali-threshold-max-comm', [config.serviceConfig[1]['time']['range']['max'] + this.$t('watersystem.period-month')]),
        (v) => v >= config.serviceConfig[1]['time']['range']['min'] || this.$t('watersystem.vali-threshold-min-comm', [config.serviceConfig[1]['time']['range']['min'] + this.$t('watersystem.period-month')]),
        (v) => this.thresholdCorrelationValidationCase2(this.flowEditData.maxUptimeLifeSpan, this.flowEditData.warningUptimeLifeSpan) || this.$t('watersystem.vali-threshold-alert-less-than')
      ],
      lifespanMonthAlertRules: [
        (v) => v.length !== 0 || this.$t('watersystem.vali-threshold-must'),
        (v) => !isNaN(v) || this.$t('watersystem.vali-threshold-num'),
        (v) => v <= config.serviceConfig[1]['time']['range']['max'] || this.$t('watersystem.vali-threshold-max-comm', [config.serviceConfig[1]['time']['range']['max'] + this.$t('watersystem.period-month')]),
        (v) => v >= config.serviceConfig[1]['time']['range']['min'] || this.$t('watersystem.vali-threshold-min-comm', [config.serviceConfig[1]['time']['range']['min'] + this.$t('watersystem.period-month')]),
        (v) => this.thresholdCorrelationValidationCase2(this.flowEditData.maxUptimeLifeSpan, this.flowEditData.warningUptimeLifeSpan) || this.$t('watersystem.vali-threshold-greater-than-warning')
      ],
      roRateWarningRules: [
        (v) => v.length !== 0 || this.$t('watersystem.vali-threshold-must'),
        (v) => !isNaN(v) || this.$t('watersystem.vali-threshold-num'),
        (v) => v <= config.serviceConfig[2]['ro']['range']['max'] || this.$t('watersystem.vali-threshold-max-comm', [config.serviceConfig[2]['ro']['range']['max'] + '%']),
        (v) => v >= config.serviceConfig[2]['ro']['range']['min'] || this.$t('watersystem.vali-threshold-min-comm', [config.serviceConfig[2]['ro']['range']['min'] + '%']),
        (v) => this.thresholdCorrelationValidationCase1(this.roEditData.alertRate, this.roEditData.warningRate) || this.$t('watersystem.vali-threshold-greater-than-alert')
      ],
      roRateAlertRules: [
        (v) => v.length !== 0 || this.$t('watersystem.vali-threshold-must'),
        (v) => !isNaN(v) || this.$t('watersystem.vali-threshold-num'),
        (v) => v <= config.serviceConfig[2]['ro']['range']['max'] || this.$t('watersystem.vali-threshold-max-comm', [config.serviceConfig[2]['ro']['range']['max'] + '%']),
        (v) => v >= config.serviceConfig[2]['ro']['range']['min'] || this.$t('watersystem.vali-threshold-min-comm', [config.serviceConfig[2]['ro']['range']['min'] + '%']),
        (v) => this.thresholdCorrelationValidationCase1(this.roEditData.alertRate, this.roEditData.warningRate) || this.$t('watersystem.vali-threshold-warning-less-than')
      ],
      pressureWarningRules: [
        (v) => v.length !== 0 || this.$t('watersystem.vali-threshold-must'),
        (v) => !isNaN(v) || this.$t('watersystem.vali-threshold-num'),
        (v) => v <= config.serviceConfig[5]['pressure']['range']['max'] || this.$t('watersystem.vali-threshold-max-comm', [config.serviceConfig[5]['pressure']['range']['max'] + this.pressureUnit]),
        (v) => v >= config.serviceConfig[5]['pressure']['range']['min'] || this.$t('watersystem.vali-threshold-min-comm', [config.serviceConfig[5]['pressure']['range']['min'] + this.pressureUnit]),
        (v) => this.thresholdCorrelationValidationPress(this.pressEditData.alertRate, this.pressEditData.warningRate) || this.thresholdCorrelationValidationPressMessage(this.pressEditData.alertRate, this.pressEditData.warningRate, 1)
      ],
      pressureAlertRules: [
        (v) => v.length !== 0 || this.$t('watersystem.vali-threshold-must'),
        (v) => !isNaN(v) || this.$t('watersystem.vali-threshold-num'),
        (v) => v <= config.serviceConfig[5]['pressure']['range']['max'] || this.$t('watersystem.vali-threshold-max-comm', [config.serviceConfig[5]['pressure']['range']['max'] + this.pressureUnit]),
        (v) => v >= config.serviceConfig[5]['pressure']['range']['min'] || this.$t('watersystem.vali-threshold-min-comm', [config.serviceConfig[5]['pressure']['range']['min'] + this.pressureUnit]),
        (v) => this.thresholdCorrelationValidationPress(this.pressEditData.alertRate, this.pressEditData.warningRate) || this.thresholdCorrelationValidationPressMessage(this.pressEditData.alertRate, this.pressEditData.warningRate, 2)
      ],
      tempretureAlertRules: [
        (v) => this.thresholdValidationTempreture(v, 'alert')
      ],
      tempretureWarningRules: [
        (v) => this.thresholdValidationTempreture(v, 'warning')
      ],
      tempretureSelectRules: [
        (v) => v.length !== 0 || this.$t('watersystem.vali-threshold-must'),
        (v) => v !== 0 || this.$t('watersystem.vali-threshold-must')
      ]
    }
  },
  methods: {
    openHelpDialog () {
      var params = this.createHelpDialogParams()
      this.$refs.childHelpDialog.openHelpDialog(params)
    },
    // 子フォームで使用するパラメータを作成
    createHelpDialogParams () {
      return {
        selectEditServiceId: this.selectEditServiceId,
        validationType: this.getCurrentServiceValidationType()
      }
    },
    getCurrentServiceValidationType () {
      // validationTypeを使用するサービスのみ参照して値を返すそれ以外は0
      var result = 0
      if (this.selectEditServiceId === 5) {
        if (this.pressEditData.isDifferentialPressure) {
          result = 1
        }
      }
      return result
    },
    settingFormValidate () {
      // 全体のバリデーションを行う
      this.$refs.settingForm.validate()
    },
    settingFormValidateReset () {
      // バリデーションのリセットを行う
      this.$refs.settingForm.reset()
    },
    updateConfig () {
      // 全体のバリデーションを行う
      if (!this.$refs.settingForm.validate()) {
        // NG
        return
      }
      // 入力値を反映する
      this.updateEditData()
      const params = {
        'filtrationSystemId': this.filtrationSystemId,
        'filtrationSystemName': this.filtrationSystemName,
        'plugins': this.editData.plugins,
        'services': this.editData.services
      }
      http.request('post', '/service2/dashboard/api/FiltrationSystems/updateConfig', params)
      .then(response => {
        const data = response.data
        if (data.result < 0) {
          // TODO エラー処理
          console.log('update Config Avarage failed. (' + data.result + ')')
          // フォームを閉じる
          this.closeSettingDialog(false)
          return
        } else if (data.status === 304) {
          console.log('Config Avarage doesn\'t need update. (' + data.status + ')')
          // フォームを閉じる
          this.closeSettingDialog(false)
          return
        }
        // フォームを閉じる（成功）
        this.closeSettingDialog(true)
        return
      })
      .catch(error => {
        // TODO エラー処理
        console.log('Config update error', error)
        // フォームを閉じる
        this.closeSettingDialog(false)
      })
    },
    openSettingDialog (params) {
      // 親フォームから呼び出される入り口
      this.setParam(params)
      this.settingFormValidateReset()
      this.setSettingDialogEditData()
      this.showSettingDialog = true
    },
    setParam (params) {
      // 親からのパラメータ受け渡し
      this.selectEditServiceId = params.selectEditServiceId
      this.selectEditPort = params.selectEditPort
      this.locationName = params.locationName
      this.filtrationSystemName = params.filtrationSystemName
      this.filtrationSystemId = params.filtrationSystemId
      this.editData = params.editData
    },
    closeSettingDialog (filterUpdate) {
      // フィルタを更新
      this.showSettingDialog = false
      if (filterUpdate === true) {
        // 閾値の変更に伴いロケーション、デバイスのステータスも変化するので全て読み直す
        location.reload()
      }
    },
    getPlugins (pluginId) {
      return new Promise((resolve, reject) => {
        http.request('get', '/service2/dashboard/api/Plugins/pluginList/' + pluginId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            console.log('pluginId=' + pluginId + ' list get failed. (' + data.result + ')')
            resolve([])
          }
          resolve(data.plugins)
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
          resolve([])
        })
      })
    },
    getFlowsensors () {
      this.getPlugins(1).then((value) => {
        this.flowsensors = value
      })
    },
    convertUnit (flow) {
      return utils.convertUnit(flow, this.unit)
    },
    reverseUnit (flow) {
      return utils.reverseUnit(flow, this.unit)
    },
    convertSecondToMonth (second) {
      return utils.convertSecondToMonth(second)
    },
    reverseSecondToMonth (second) {
      return utils.reverseSecondToMonth(second)
    },
    convertPressureUnit (pressure) {
      return utils.convertPressureUnit(pressure, this.pressureUnit)
    },
    reversePressureUnit (pressure) {
      return utils.reversePressureUnit(pressure, this.pressureUnit)
    },
    convertMaxLifeSpanFlow (maxLifeSpanFlow) {
      let max = Math.round(this.convertUnit(maxLifeSpanFlow * 1000)) / 1000
      let maxNumFormated = utils.numberFormatter(max, this.locale)
      return maxNumFormated
    },
    reverseMaxLifeSpanFlow (maxLifeSpanFlow) {
      let max = Math.round(this.reverseUnit(maxLifeSpanFlow * 1000)) / 1000
      let maxNumFormated = utils.numberFormatter(max, this.locale)
      return maxNumFormated
    },
    setSettingDialogEditData () {
      // 編集中のデータを初期化
      this.initEditData()
      for (var i = 0; i < this.editData.services.length; i++) {
        if (this.editData.services[i].serviceId === this.selectEditServiceId) {
          if (this.selectEditServiceId === 1) {
            this.setEditDataFrow(this.editData.services[i])
            return
          } else if (this.selectEditServiceId === 2) {
            this.setEditDataRo(this.editData.services[i])
            return
          } else if (this.selectEditServiceId === 3 && this.editData.services[i].portNumber === this.selectEditPort) {
            this.setEditDataTempreture(this.editData.services[i], this.editData.plugins[i])
            return
          } else if (this.selectEditServiceId === 5 && this.editData.services[i].portNumber === this.selectEditPort) {
            this.setEditDataPress(this.editData.services[i])
            return
          }
        }
      }
    },
    setEditDataFrow (service) {
      this.flowEditData.maxFlowLifeSpan = Math.round(this.convertUnit(service.params.filters[0].maxFlowLifeSpan))
      this.flowEditData.warningFlowLifeSpan = Math.round(this.convertUnit(service.params.filters[0].warningFlowLifeSpan))
      this.flowEditData.maxUptimeLifeSpan = this.convertSecondToMonth(service.params.filters[0].maxUptimeLifeSpan)
      this.flowEditData.warningUptimeLifeSpan = this.convertSecondToMonth(service.params.filters[0].warningUptimeLifeSpan)
      this.setEditDataFrowPluginInfoId(this.editData.plugins)
    },
    setEditDataFrowPluginInfoId (plugins) {
      for (var i = 0; i < plugins.length; i++) {
        if (plugins[i].serviceId === 1) {
          this.flowEditData.pluginInfoId = plugins[i].pluginInfoId
        }
      }
    },
    setEditDataRo (service) {
      this.roEditData.alertRate = service.params.alertRate
      this.roEditData.warningRate = service.params.warningRate
    },
    setEditDataTempreture (service, plugin) {
      var selectTempretureItem = ''
      if (service.serviceId === 3 && service.portNumber === this.selectEditPort) {
        this.temperatureEditData.portNumber = service.portNumber
        if (service.params.validationType === 1) {
          selectTempretureItem = this.$t('watersystem.temperature-increase')
        }
        if (service.params.validationType === 2) {
          selectTempretureItem = this.$t('watersystem.temperature-decrease')
        }
        this.selectTempretureItem = selectTempretureItem
        this.temperatureEditData.validationType = service.params.validationType
        this.temperatureEditData.alertRate.min = utils.convertTemperatureUnit(service.params.settingData.temperature[0].alertRate.min, this.temperatureUnit)
        this.temperatureEditData.alertRate.max = utils.convertTemperatureUnit(service.params.settingData.temperature[0].alertRate.max, this.temperatureUnit)
        this.temperatureEditData.warningRate.min = utils.convertTemperatureUnit(service.params.settingData.temperature[0].warningRate.min, this.temperatureUnit)
        this.temperatureEditData.warningRate.max = utils.convertTemperatureUnit(service.params.settingData.temperature[0].warningRate.max, this.temperatureUnit)
        this.temperatureEditData.plugin = plugin
      }
    },
    setEditDataPress (service) {
      if (service.serviceId === 5 && service.portNumber === this.selectEditPort) {
        this.pressEditData.portNumber = service.portNumber
        this.pressEditData.alertRate = this.convertPressureUnit(service.params.alertRate)
        this.pressEditData.warningRate = this.convertPressureUnit(service.params.warningRate)
        // 差圧かどうか
        if (service.params.validationType === 0) {
          this.pressEditData.isDifferentialPressure = false
        } else if (service.params.validationType === 1) {
          this.pressEditData.isDifferentialPressure = true
        }
      }
    },
    updateEditData () {
      for (var i = 0; i < this.editData.services.length; i++) {
        if (this.editData.services[i].serviceId === this.selectEditServiceId) {
          if (this.selectEditServiceId === 1) {
            this.updateEditDataFrow(this.editData.services[i])
            return
          } else if (this.selectEditServiceId === 2) {
            this.updateEditDataRo(this.editData.services[i])
            return
          } else if (this.selectEditServiceId === 3) {
            this.updateEditDataTempreture(this.editData.services)
            return
          } else if (this.selectEditServiceId === 5) {
            this.updateEditDataPress(this.editData.services)
            return
          }
        }
      }
    },
    updateEditDataFrow (service) {
      service.params.filters[0].maxFlowLifeSpan = this.reverseUnit(this.flowEditData.maxFlowLifeSpan)
      service.params.filters[0].warningFlowLifeSpan = this.reverseUnit(this.flowEditData.warningFlowLifeSpan)
      service.params.filters[0].maxUptimeLifeSpan = this.reverseSecondToMonth(this.flowEditData.maxUptimeLifeSpan)
      service.params.filters[0].warningUptimeLifeSpan = this.reverseSecondToMonth(this.flowEditData.warningUptimeLifeSpan)
      this.updateEditDataFrowPluginInfoId(this.editData.plugins)
    },
    updateEditDataFrowPluginInfoId (plugins) {
      for (var i = 0; i < plugins.length; i++) {
        if (plugins[i].serviceId === 1) {
          plugins[i].pluginInfoId = this.flowEditData.pluginInfoId
        }
      }
    },
    updateEditDataRo (service) {
      service.params.alertRate = this.roEditData.alertRate
      service.params.warningRate = this.roEditData.warningRate
    },
    updateEditDataTempreture (services) {
      for (var i = 0; i < services.length; i++) {
        if (services[i].serviceId === 3 && services[i].portNumber === this.temperatureEditData.portNumber) {
          services[i].params.validationType = this.temperatureEditData.validationType
          // TODO: しきい値を複数設定する際改修が必要、現在は固定0番目に入れる
          if (parseInt(this.temperatureEditData.validationType) === 1) {
            services[i].params.settingData.temperature[0].alertRate.min = utils.reverseTemperatureUnit(this.temperatureEditData.alertRate.min, this.temperatureUnit)
            services[i].params.settingData.temperature[0].alertRate.max = ''
            services[i].params.settingData.temperature[0].warningRate.min = utils.reverseTemperatureUnit(this.temperatureEditData.warningRate.min, this.temperatureUnit)
            services[i].params.settingData.temperature[0].warningRate.max = ''
          } else if (parseInt(this.temperatureEditData.validationType) === 2) {
            services[i].params.settingData.temperature[0].alertRate.min = ''
            services[i].params.settingData.temperature[0].alertRate.max = utils.reverseTemperatureUnit(this.temperatureEditData.alertRate.max, this.temperatureUnit)
            services[i].params.settingData.temperature[0].warningRate.min = ''
            services[i].params.settingData.temperature[0].warningRate.max = utils.reverseTemperatureUnit(this.temperatureEditData.warningRate.max, this.temperatureUnit)
          }
        }
      }
    },
    updateEditDataPress (services) {
      for (var i = 0; i < services.length; i++) {
        if (services[i].serviceId === 5 && services[i].portNumber === this.pressEditData.portNumber) {
          services[i].params.alertRate = this.reversePressureUnit(this.pressEditData.alertRate)
          services[i].params.warningRate = this.reversePressureUnit(this.pressEditData.warningRate)
          // 差圧かどうか
          if (this.pressEditData.isDifferentialPressure) {
            services[i].params.validationType = 1
          } else {
            services[i].params.validationType = 0
          }
        }
      }
    },
    settingBtnsDisabled (services) {
      for (var i = 0; i < services.length; i++) {
        this.settingBtnDisabled(services[i])
      }
    },
    initEditData () {
      this.flowEditData.maxFlowLifeSpan = ''
      this.flowEditData.warningFlowLifeSpan = ''
      this.flowEditData.maxUptimeLifeSpan = ''
      this.flowEditData.warningUptimeLifeSpan = ''
      this.flowEditData.pluginInfoId = ''
      this.roEditData.alertRate = ''
      this.roEditData.warningRate = ''
      this.pressEditData.portNumber = ''
      this.pressEditData.alertRate = ''
      this.pressEditData.warningRate = ''
    },
    thresholdCorrelationValidationCase1 (alertValue, warningValue) {
      // 値が低くなるほど状態が悪い場合
      if (!isNaN(alertValue) && !isNaN(warningValue)) {
        return parseFloat(alertValue) < parseFloat(warningValue)
      }
      // 比較できない場合はチェックしない
      return true
    },
    thresholdCorrelationValidationCase2 (alertValue, warningValue) {
      // 値が大きくなるほど状態が悪い場合
      if (!isNaN(alertValue) && !isNaN(warningValue)) {
        return parseFloat(alertValue) > parseFloat(warningValue)
      }
      // 比較できない場合はチェックしない
      return true
    },
    thresholdValidationTempreture (v, notificationType) {
      if (isNaN(v)) {
        return this.$t('watersystem.vali-threshold-num')
      }
      if (v.length === 0) {
        return this.$t('watersystem.vali-threshold-must')
      }
      if (v < utils.convertTemperatureUnit(this.temperatureEditData.plugin.pluginMetadata.temperature.min, this.temperatureUnit)) {
        return this.$t('watersystem.vali-threshold-min-comm', [utils.convertTemperatureUnit(this.temperatureEditData.plugin.pluginMetadata.temperature.min, this.temperatureUnit) + this.temperatureUnit])
      }
      if (v > utils.convertTemperatureUnit(this.temperatureEditData.plugin.pluginMetadata.temperature.max, this.temperatureUnit)) {
        return this.$t('watersystem.vali-threshold-max-comm', [utils.convertTemperatureUnit(this.temperatureEditData.plugin.pluginMetadata.temperature.max, this.temperatureUnit) + this.temperatureUnit])
      }
      switch (parseInt(this.temperatureEditData.validationType)) {
        case 1:
          if (parseFloat(this.temperatureEditData.warningRate.min) >= parseFloat(this.temperatureEditData.alertRate.min)) {
            if (notificationType === 'alert') {
              return this.$t('watersystem.vali-threshold-greater-than-warning')
            }
            if (notificationType === 'warning') {
              return this.$t('watersystem.vali-threshold-alert-less-than')
            }
          }
          break
        case 2:
          if (parseFloat(this.temperatureEditData.warningRate.max) <= parseFloat(this.temperatureEditData.alertRate.max)) {
            if (notificationType === 'alert') {
              return this.$t('watersystem.vali-threshold-warning-less-than')
            }
            if (notificationType === 'warning') {
              return this.$t('watersystem.vali-threshold-greater-than-alert')
            }
          }
          break
      }
      return true
    },
    thresholdCorrelationValidationPress (alertValue, warningValue) {
      // 動的に条件を判定
      if (!isNaN(alertValue) && !isNaN(warningValue)) {
        if (this.pressEditData.isDifferentialPressure) {
          // 差圧
          return parseFloat(alertValue) > parseFloat(warningValue)
        } else {
          // 圧力値
          return parseFloat(alertValue) < parseFloat(warningValue)
        }
      }
    },
    thresholdCorrelationValidationPressMessage (alertValue, warningValue, inputValueType) {
      // inputValueType 1:warning 2:alert
      // 動的にメッセージを返す
      if (!isNaN(alertValue) && !isNaN(warningValue)) {
        if (this.pressEditData.isDifferentialPressure) {
          // 差圧
          if (inputValueType === 1) {
            return this.$t('watersystem.vali-threshold-alert-less-than')
          } else if (inputValueType === 2) {
            return this.$t('watersystem.vali-threshold-greater-than-warning')
          }
        } else {
          // 圧力値
          if (inputValueType === 1) {
            return this.$t('watersystem.vali-threshold-greater-than-alert')
          } else if (inputValueType === 2) {
            return this.$t('watersystem.vali-threshold-warning-less-than')
          }
        }
      }
      // 比較できない場合はからを返却
      return ''
    },
    init () {
      this.setExecBtnProperty() // 保存ボタンの属性をセット
      this.getFlowsensors() // Pluginデータ取得
    },
    // 保存ボタンの属性をセットする
    setExecBtnProperty () {
      this.isRoot = utils.isRoot(this.$store.getters.user.roles) // ルートかどうかを判定
      if (this.isRoot) {
        this.execBtnName = this.$t('aplix-use-only.btn.can-not-save')
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>
.setting-dialog-threshold-h{
  margin-top: auto;
  margin-bottom: auto;
}
</style>



// WEBPACK FOOTER //
// ServiceSettingDialog.vue?a780079e